//Driver for viewing a response without opportunity to submit a score
//But can submit comments

import axios from "axios";

export default {
	icon: "check",
	name: "Viewing",
	showScores() {
		return false;
	},
	sidebarType() {
		return "viewing";
	},
	canBeEscalated: true,

	enter(vue, assessmentID, itemID, responseID) {
		let url = `/view/${assessmentID}/${itemID}/${responseID}`;
		console.log("url", url);
		var query = { return: true };
		vue.$router.push({ path: url, query: query });
	},

	getNext(ctx) {
		var promise = axios.get(`/v3/response/${ctx.response_id}`);
		promise.then(function(resp) {
			console.log("ViewingSD GetNext:" + resp.data.response.ref_id);
		});
		return promise;
	}
};



// WEBPACK FOOTER //
// ./src/services/ScoringDrivers/ViewingDriver.js